import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mx-6"
};
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ListPageShell from '@/components/ListPageShell.vue';
import WealthOperationApplyBusinessDetail from '../components/WealthOperationApplyBusinessDetail.vue';
export default {
  __name: 'detail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const applyId = computed(() => Number(route.params.id));
    function goBack() {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.push('/wealth/customers');
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "资金申请详情"), _createElementVNode("p", {
          class: "list-page-description"
        }, "用于审批中心查看财富资金操作的业务详情。")], -1)), _createElementVNode("div", {
          class: "list-page-heading-actions"
        }, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: goBack
        }, "返回")])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(WealthOperationApplyBusinessDetail, {
          "apply-id": applyId.value
        }, null, 8, ["apply-id"])])]),
        _: 1
      });
    };
  }
};